var _style, _path, _path2, _path3, _path4, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoudpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 287.04",
    style: {
      enableBackground: "new 0 0 1000 287.04"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000039843087368053902360000013172870941122345900_);}\r\n\t.st2{fill:url(#SVGID_00000176731979913430554410000005300138780269620390_);}\r\n\t.st3{fill:url(#SVGID_00000170993033154939932000000000748608773870733470_);}\r\n\t.st4{fill:url(#SVGID_00000097478606044809378050000017811330292345613229_);}\r\n\t.st5{fill:url(#SVGID_00000160887780216563257220000002401935958961215418_);}\r\n\t.st6{fill:url(#SVGID_00000006668705814177735860000013344556597557517461_);}\r\n\t.st7{fill:url(#SVGID_00000003068023067539237010000015454133585720043702_);}\r\n\t.st8{fill:url(#SVGID_00000181079073706504781610000015870518962010553485_);}\r\n\t.st9{fill:url(#SVGID_00000073720760272185952320000012947214548673257656_);}\r\n\t.st10{fill:url(#SVGID_00000107556275137610998400000007361189309426026162_);}\r\n\t.st11{fill:url(#SVGID_00000165955439835600719430000005405627424857816485_);}\r\n\t.st12{fill:url(#SVGID_00000047778178862623813490000006827753442775346857_);}\r\n\t.st13{fill:url(#SVGID_00000022533830106068323860000017053812957801936531_);}\r\n\t.st14{fill:url(#SVGID_00000062180996316967398300000014042225224328005775_);}\r\n\t.st15{fill:url(#SVGID_00000142170470399962636740000015984159134899830927_);}\r\n\t.st16{fill:#FFFFFF;}\r\n\t.st17{fill:url(#SVGID_00000005954937600952663970000012063140520047103361_);}\r\n\t.st18{fill:url(#SVGID_00000109709063258646491770000004831837678775082640_);}\r\n\t.st19{fill:url(#SVGID_00000036244838929232880310000011868915357377313452_);}\r\n\t.st20{fill:url(#SVGID_00000136387067525979633180000005014798229152593567_);}\r\n\t.st21{fill:url(#SVGID_00000133501576788351179450000015355359075173358245_);}\r\n\t.st22{fill:url(#SVGID_00000001635317555275576070000009799396249327427007_);}\r\n\t.st23{fill:url(#SVGID_00000106825855686111427260000000374448647104002959_);}\r\n\t.st24{fill:url(#SVGID_00000178193263120046993210000005923722829043977347_);}\r\n\t.st25{fill:url(#SVGID_00000062189157501795779120000015974295737621899151_);}\r\n\t.st26{fill:url(#SVGID_00000154395277697151926030000016071425356998310813_);}\r\n\t.st27{fill:url(#SVGID_00000133524062043830558570000016157698487579090065_);}\r\n\t.st28{fill:url(#SVGID_00000107575951241273546300000003938972682990719141_);}\r\n\t.st29{fill:url(#SVGID_00000109712364393942259590000010709234369511733923_);}\r\n\t.st30{fill:url(#SVGID_00000067221227023290650440000017890733919668608950_);}\r\n\t.st31{fill:url(#SVGID_00000132048862044663503720000002196897352813814168_);}\r\n\t.st32{fill:url(#SVGID_00000042732709200629636140000015107240724804192678_);}\r\n\t.st33{fill:url(#SVGID_00000003105947247710070180000004540452800023054485_);}\r\n\t.st34{fill:url(#SVGID_00000085251111551235636660000013967924454059854468_);}\r\n\t.st35{fill:#111047;}\r\n\t.st36{fill:#FF9900;}\r\n\t.st37{fill:url(#SVGID_00000044156513086391833130000002007509095456543408_);}\r\n\t.st38{fill:url(#SVGID_00000002354976070362441880000006826767685692998576_);}\r\n\t.st39{fill:url(#SVGID_00000068650909004799708830000001546763055462261895_);}\r\n\t.st40{fill:url(#SVGID_00000157294992451130546280000008488398190850539699_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.8831,
    y1: 112.2966,
    x2: 278.3054,
    y2: 212.1684,
    gradientTransform: "matrix(1 0 0 -1 0 289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#111047"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2124BA"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M268.24,56.65c-0.17,5.09-0.5,10.14-0.97,15.17c-0.12,1.34-0.26,2.68-0.4,4.01c0,0,0.01,0.01,0,0.02 c-0.15,1.33-0.29,2.66-0.46,3.97c-0.13,1.1-0.27,2.18-0.41,3.27c-0.05,0.37-0.1,0.73-0.16,1.1c-0.16,1.19-0.34,2.39-0.52,3.58 c-0.15,0.99-0.3,1.97-0.48,2.96c-0.39,2.39-0.82,4.75-1.27,7.12c-0.17,0.8-0.33,1.6-0.49,2.4 c-14.94,73.8-60.36,137.28-123.38,175.64h-0.01C72.11,234.76,24.72,164.72,13.52,84.06c-0.05-0.32-0.09-0.65-0.13-0.96 c-0.15-1.08-0.29-2.17-0.41-3.27c-0.17-1.32-0.32-2.64-0.46-3.97c0,0,0-0.01,0-0.02c-0.15-1.33-0.28-2.67-0.4-4.01h0.01 c-0.46-5.02-0.8-10.08-0.99-15.16C46.25,28.2,90.98,11.15,139.69,11.15C188.41,11.15,233.13,28.2,268.24,56.65z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127025239887357161000000015428469442437959052_",
    gradientUnits: "userSpaceOnUse",
    x1: 96.8672,
    y1: 161.19,
    x2: 135.58,
    y2: 161.19,
    gradientTransform: "matrix(1 0 0 -1 0 289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDEE07"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127025239887357161000000015428469442437959052_)"
    },
    d: "M135.58,159.57 c-42.82-43.46-14.93-63.52-14.93-63.52C74.3,100.54,104.73,139.85,135.58,159.57z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000077292898614786763020000006747904556598757788_",
    gradientUnits: "userSpaceOnUse",
    x1: 96.8642,
    y1: 161.2,
    x2: 135.57,
    y2: 161.2,
    gradientTransform: "matrix(1 0 0 -1 0 289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDEE07"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000077292898614786763020000006747904556598757788_)"
    },
    d: "M120.09,96.49 c0.35-0.3,0.55-0.45,0.55-0.45c-46.34,4.49-15.91,43.8,14.93,63.52c-2.07-2.1-3.98-4.15-5.73-6.15 C103.47,133.27,83.04,102.06,120.09,96.49z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075848826008394794350000004931627949722094222_",
    gradientUnits: "userSpaceOnUse",
    x1: 136.73,
    y1: 93.24,
    x2: 194.2505,
    y2: 93.24,
    gradientTransform: "matrix(1 0 0 -1 0 289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDEE07"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075848826008394794350000004931627949722094222_)"
    },
    d: "M194.23,194.64 c-19.19-8.81-37.92,20.75-57.5-15.38c2.82,25.72,14.57,33,34.87,33C184.17,212.26,194.78,206.01,194.23,194.64z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104695367742978935560000017432344166242622136_",
    gradientUnits: "userSpaceOnUse",
    x1: 136.73,
    y1: 93.23,
    x2: 192.55,
    y2: 93.23,
    gradientTransform: "matrix(1 0 0 -1 0 289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDEE07"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000104695367742978935560000017432344166242622136_)"
    },
    d: "M172.47,210.83 c-19.23,0-30.78-6.54-34.34-29.1c-0.47-0.79-0.93-1.6-1.4-2.46c2.82,25.72,14.57,33,34.87,33c9.3,0,17.52-3.43,20.95-9.82 C188.71,207.91,181.05,210.83,172.47,210.83z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120543357025076238480000008214683564104073400_",
    gradientUnits: "userSpaceOnUse",
    x1: 157.4853,
    y1: 125.4744,
    x2: 216.9895,
    y2: 125.4744,
    gradientTransform: "matrix(1 0 0 -1 0 289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDEE07"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000120543357025076238480000008214683564104073400_)"
    },
    d: "M202.13,159.83 c10.26-2.17,15.63-10.36,14.77-17.39c-2.85,0.08-5.66-1.25-7.64-4.2c-9.62,6.12-23.24,6.21-35.11,4.2c0,0,1.11,11.94-4.62,20.01 c0,0,10.34-2.4,14.59-16.62l3.02,3.14c0,0,10.77-6.46,24.87-3.14C206.63,147.82,207.33,155.43,202.13,159.83z M197.15,172.19 c0,0-5.51,5.47-2.27,6.44c-4.49,3.34-17.28,2.33-21.41-0.32c0,0-2.55,3.38-5.42,5c0,0,1.25-6.48,0.14-12.07 c0,0-4.61,8.01-9.82,12.73c-1.09,0.99-1.18,2.68-0.23,3.82c0.69,0.83,1.8,1.21,2.85,0.93c12.03-3.1,22.81-7.83,33.26-3.12 C194.25,185.6,199.23,181.36,197.15,172.19z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000174579971143584436810000002229192688920798380_",
    gradientUnits: "userSpaceOnUse",
    x1: 169.53,
    y1: 136.1044,
    x2: 212.4,
    y2: 136.1044,
    gradientTransform: "matrix(1 0 0 -1 0 289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDEE07"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000174579971143584436810000002229192688920798380_)"
    },
    d: "M184.12,145.83l3.02,3.14 c0,0,9.97-5.95,23.26-3.46c0.56-0.5,1.21-0.93,2-1.22c-14.1-3.32-24.87,3.14-24.87,3.14l-3.02-3.14 c-3.59,12-11.49,15.57-13.88,16.4c-0.34,0.6-0.7,1.19-1.1,1.76C169.53,162.45,179.88,160.05,184.12,145.83z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013898990789582806930000004334054567543105182_",
    gradientUnits: "userSpaceOnUse",
    x1: 202.13,
    y1: 135.89,
    x2: 216.74,
    y2: 135.89,
    gradientTransform: "matrix(1 0 0 -1 0 289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDEE07"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013898990789582806930000004334054567543105182_)"
    },
    d: "M203.9,157.94 c-0.51,0.67-1.09,1.31-1.77,1.89c8.37-1.77,13.48-7.55,14.61-13.44C215.19,151.39,210.75,156.05,203.9,157.94z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000901082563785049660000001712010128476044708_",
    gradientUnits: "userSpaceOnUse",
    x1: 173.3024,
    y1: 141.03,
    x2: 174.6215,
    y2: 141.03,
    gradientTransform: "matrix(1 0 0 -1 0 289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDEE07"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000901082563785049660000001712010128476044708_)"
    },
    d: "M173.3,153.5 c1.24-4.46,1.36-8.75,1.31-10.99c-0.15-0.03-0.31-0.05-0.46-0.07C174.15,142.44,174.62,147.65,173.3,153.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000153696153516072213160000007718600778943241662_",
    gradientUnits: "userSpaceOnUse",
    x1: 193.8735,
    y1: 112.095,
    x2: 195.2683,
    y2: 112.095,
    gradientTransform: "matrix(1 0 0 -1 0 289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDEE07"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000153696153516072213160000007718600778943241662_)"
    },
    d: "M193.95,177.83 c0.49-0.22,0.94-0.46,1.32-0.74c-0.68-0.2-0.96-0.61-1-1.11C193.93,176.67,193.77,177.32,193.95,177.83z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137851558573872142980000014739942717304778915_",
    gradientUnits: "userSpaceOnUse",
    x1: 157.4938,
    y1: 104.9244,
    x2: 197.41,
    y2: 104.9244,
    gradientTransform: "matrix(1 0 0 -1 0 289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDEE07"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137851558573872142980000014739942717304778915_)"
    },
    d: "M194.64,184.07 c-10.46-4.72-21.23,0.01-33.26,3.12c-1.05,0.27-2.16-0.1-2.85-0.93c-0.4-0.49-0.61-1.08-0.64-1.68c-0.6,0.99-0.52,2.28,0.25,3.21 c0.69,0.83,1.8,1.21,2.85,0.93c12.03-3.1,22.81-7.83,33.26-3.12c0,0,2.36-2.01,3.16-6.26 C196.42,182.53,194.64,184.07,194.64,184.07z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127033645882919629740000007865386126169970364_",
    gradientUnits: "userSpaceOnUse",
    x1: 216.2054,
    y1: 167.0479,
    x2: 232.5506,
    y2: 167.0479,
    gradientTransform: "matrix(1 0 0 -1 0 289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDEE07"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127033645882919629740000007865386126169970364_)"
    },
    d: "M232.51,116.64 c-2.36,4.42-7.09,5.23-7.09,5.23c3.11-5.85,1.49-12.32,1.49-12.32c-3.55,6.66-9.92,7.34-10.58,16.67 c-1.23,7.52,6.91,11.01,12.75,5.29c-3.05,0.37-4.98-1.49-4.98-1.49C233.63,125.78,232.51,116.64,232.51,116.64z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169524782850965615460000003783902053188657305_",
    gradientUnits: "userSpaceOnUse",
    x1: 202.0314,
    y1: 284.1397,
    x2: 43.2649,
    y2: 57.0996,
    gradientTransform: "matrix(1 0 0 -1 0 289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDEE07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9900"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000169524782850965615460000003783902053188657305_)"
    },
    d: "M260.37,112.28 c-17.25,68.65-61.1,127.35-120.67,163.61c-1.17-0.71-2.32-1.46-3.48-2.2l0.01,0.01c-0.03-0.02-0.05-0.03-0.07-0.05 c-3.56-2.24-7.07-4.54-10.51-6.94c0.02-0.01,0.04-0.02,0.06-0.04c-40.42-28.21-72.38-67.1-92.18-112.14 c24.06-19.12,46.78-28.2,46.78-28.2c-4.74,36.74,46.71,67.63,46.71,67.63s-35.14-9.22-48.2-25.98c0,0-3.33,53.28,48,98.07 C187.44,232.4,235.22,178.11,260.37,112.28z M74.96,106.55c-11.85-3.15-26.1-12.93-26.1-12.93s-4.97,1.81-12.35,5.05 c-1.55-10.18-2.54-20.52-2.9-30.98c33.79-27.22,76.38-43.94,122.84-45.22c1.88-0.04,3.76-0.08,5.64-0.08c0.03,0,0.05,0,0.08,0 c1.85,0,3.69,0.04,5.54,0.08c26.42,0.7,51.58,6.41,74.6,16.19c-28.69-16.61-61.76-26.49-97.07-27.42 c-1.85-0.03-3.69-0.08-5.54-0.08c-0.03,0-0.05,0-0.08,0c-1.88,0-3.76,0.04-5.64,0.08c-46.46,1.27-89.05,18-122.84,45.22 c0.6,17.47,2.94,34.58,6.81,51.16c-0.01,0.01-0.02,0.01-0.03,0.02c0.34,1.46,0.71,2.9,1.08,4.35c0.12,0.47,0.23,0.94,0.35,1.41 c0.55,2.14,1.13,4.27,1.73,6.38c0.1,0.34,0.18,0.69,0.28,1.04h0.01c1.38,4.8,2.89,9.55,4.53,14.24 C47.7,119.34,74.96,106.55,74.96,106.55z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047050235705025847150000006681542702514966704_",
    gradientUnits: "userSpaceOnUse",
    x1: 128.1123,
    y1: 185.7792,
    x2: 193.7921,
    y2: 238.1177,
    gradientTransform: "matrix(1 0 0 -1 0 289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDEE07"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047050235705025847150000006681542702514966704_)"
    },
    d: "M115.34,75.97 c11.24-6.64,22.53-7.82,33.9-1.88l-2.96-7.23c11.09,2.08,20.76,6.07,28.65,12.48c0.3-2.07,0.6-4.11,1.97-4.51 c5.52,6.2,11.55,11.93,18,17.29c-8.73-0.26-17.61,1.92-25.37,5.73c0,0,1.25,9.64,15.16,14.46c-14.59,3.98-29.05,0.8-39.65-8.11 c0,0,2.43,18.48,39.93,19.17c-4.69,8.3-24.79,7.48-34.51,0c9.77,13.76,35.2,17.06,48.98,12.31c4.31-1.49,7.85-4.81,9.44-9.09 c4.41-11.83-12.73-13.33-16.85-25.89c10.12,3.97,19.79,4.97,28.8,1.67c-4.71-4.37-10.1-7.18-15.78-8.75c2-1.58,4.62-2.56,7.78-3.03 c-1.09-2.35-1.89-4.71-2.3-7.06c4.26,0.48,8.64,1.51,13.13,3.04c-8.69-9.38-18.66-16.35-30.37-20.03c2.18,2.42,3.86,5.08,5.24,7.9 c-23.54-20.08-65.34-25.03-93.74-14.42l8.52,1.32C94.88,72.27,71.66,76.68,46.2,78.04c0,0,8.54,11.98,41.45,15.59 C80.26,90.74,74.34,87.25,72,82.29c15.24-2.36,30.31-7.38,45.23-14.69L115.34,75.97z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041287400124030905120000011927496402277372607_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.96,
    y1: 200.2955,
    x2: 161.63,
    y2: 200.2955,
    gradientTransform: "matrix(1 0 0 -1 0 289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDEE07"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000041287400124030905120000011927496402277372607_)"
    },
    d: "M147.59,81.88 c-8.41-0.23-15.03,1.59-15.63,10.35c0,0,12.49,6.65,29.67,1.12C161.62,93.34,150.42,89.91,147.59,81.88z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066508124932679200020000005314170738581639835_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.96,
    y1: 200.1091,
    x2: 158.71,
    y2: 200.1091,
    gradientTransform: "matrix(1 0 0 -1 0 289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDEE07"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000066508124932679200020000005314170738581639835_)"
    },
    d: "M133.6,91.86 c0.39-5.68,3.32-8.43,7.62-9.61c-5.19,0.91-8.83,3.6-9.26,9.97c0,0,11.1,5.9,26.75,1.95C143.93,97.33,133.6,91.86,133.6,91.86z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M158.16,80.03c0,0-1.04,6.99,11.38,7.11C166.5,83.96,162.71,81.59,158.16,80.03z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M222.67,97.32c0,0,1.6-1.2,1.44-3.41c0,0-4.2-0.34-5.77,0C218.35,93.92,221.23,94.87,222.67,97.32z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176728706398873497750000014612931472507638945_",
    gradientUnits: "userSpaceOnUse",
    x1: 126.46,
    y1: 57.81,
    x2: 152.87,
    y2: 57.81,
    gradientTransform: "matrix(1 0 0 -1 0 289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDEE07"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000176728706398873497750000014612931472507638945_)"
    },
    points: "136.48,234.15 139.67,244.4  142.86,234.15 152.87,231.19 142.86,228.22 139.67,217.98 136.48,228.22 126.46,231.19  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122703601914669183230000003871855297447240343_",
    gradientUnits: "userSpaceOnUse",
    x1: 120.0342,
    y1: 90.9155,
    x2: 80.1068,
    y2: 158.5424,
    gradientTransform: "matrix(1 0 0 -1 0 289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDEE07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9900"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000122703601914669183230000003871855297447240343_)"
    },
    d: "M77.61,127.5 c-2.44,35.75,46.93,65.38,46.93,65.38s-8.87-2.33-19.35-6.77c11.52,5.14,21.83,7.85,21.83,7.85s-51.46-30.89-46.71-67.63 C80.31,126.34,79.34,126.73,77.61,127.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124132978837290746720000004067410670854588068_",
    gradientUnits: "userSpaceOnUse",
    x1: 112.0037,
    y1: 32.808,
    x2: 79.5627,
    y2: 119.8996,
    gradientTransform: "matrix(1 0 0 -1 0 289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDEE07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9900"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124132978837290746720000004067410670854588068_)"
    },
    d: "M78.78,169.69 c-0.88-0.9-1.7-1.83-2.44-2.78c0,0-3.33,53.28,48,98.07c0.26-0.14,0.51-0.3,0.77-0.44C80.84,224.8,78.72,178.98,78.78,169.69z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060024896517746594180000013472355488415090080_",
    gradientUnits: "userSpaceOnUse",
    x1: 137.6,
    y1: 94.925,
    x2: 260.37,
    y2: 94.925,
    gradientTransform: "matrix(1 0 0 -1 0 289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDEE07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9900"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060024896517746594180000013472355488415090080_)"
    },
    d: "M251.03,134.01 c-20.45,58.63-60.77,108.37-113.43,140.55c0.7,0.44,1.39,0.89,2.1,1.32c59.56-36.26,103.42-94.96,120.67-163.61 C257.54,119.67,254.42,126.92,251.03,134.01z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065773655282943838170000014010875582011016083_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.12,
    y1: 168.64,
    x2: 74.97,
    y2: 168.64,
    gradientTransform: "matrix(1 0 0 -1 0 289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDEE07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9900"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065773655282943838170000014010875582011016083_)"
    },
    d: "M72.06,105.67 c-3.35,1.6-27.01,13.04-46.94,27.08c0.26,0.77,0.5,1.54,0.77,2.3c21.82-15.71,49.08-28.5,49.08-28.5 C74.01,106.3,73.04,106,72.06,105.67z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181084336548068572300000017076104811791026864_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.33,
    y1: 190.625,
    x2: 65.72,
    y2: 190.625,
    gradientTransform: "matrix(1 0 0 -1 0 289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDEE07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9900"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181084336548068572300000017076104811791026864_)"
    },
    d: "M65.72,103.13 c-8.94-4.07-16.86-9.51-16.86-9.51s-0.19,0.07-0.53,0.2C51.59,95.92,58.53,100.15,65.72,103.13z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083808835935368223900000005035040635219552698_",
    gradientUnits: "userSpaceOnUse",
    x1: 83.8345,
    y1: 216.4396,
    x2: 120.3811,
    y2: 245.5627,
    gradientTransform: "matrix(1 0 0 -1 0 289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDEE07"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083808835935368223900000005035040635219552698_)"
    },
    d: "M53.41,77.55 c23.68-1.63,45.25-6.14,62.57-16.42l-8.52-1.32c6.95-2.6,14.71-4.25,22.8-4.99c-9.05,0.6-17.74,2.32-25.45,5.2l8.52,1.32 C96.66,71.22,76.05,75.76,53.41,77.55z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010996455488684615120000014429257800896168839_",
    gradientUnits: "userSpaceOnUse",
    x1: 202.5093,
    y1: 185.4743,
    x2: 208.8274,
    y2: 190.509,
    gradientTransform: "matrix(1 0 0 -1 0 289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDEE07"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010996455488684615120000014429257800896168839_)"
    },
    d: "M194.69,100.48 c0.15,0.46,0.33,0.91,0.51,1.34c6.28,2.09,12.37,2.95,18.23,2.28C207.41,104.33,201.14,103.01,194.69,100.48z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170980302962448391990000015045860874129691326_",
    gradientUnits: "userSpaceOnUse",
    x1: 197.3052,
    y1: 218.6611,
    x2: 198.4587,
    y2: 219.5802,
    gradientTransform: "matrix(1 0 0 -1 0 289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDEE07"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170980302962448391990000015045860874129691326_)"
    },
    d: "M201.2,74.22 c-1.08-2.2-2.35-4.31-3.89-6.28c-1.31-0.51-2.64-0.99-3.99-1.41c1.12,1.24,2.11,2.56,2.99,3.92 C198.01,71.64,199.65,72.9,201.2,74.22z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178918015752091030610000001723828145295956614_",
    gradientUnits: "userSpaceOnUse",
    x1: 187.1312,
    y1: 204.6811,
    x2: 189.7695,
    y2: 206.7835,
    gradientTransform: "matrix(1 0 0 -1 0 289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDEE07"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178918015752091030610000001723828145295956614_)"
    },
    d: "M178.18,76.2 c5.11,5.59,10.62,10.82,16.5,15.72c0.96-0.03,1.91-0.04,2.87-0.01c-6.45-5.36-12.48-11.09-18-17.29 C178.88,74.81,178.46,75.41,178.18,76.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116216423344500224560000002210068444900369842_",
    gradientUnits: "userSpaceOnUse",
    x1: 160.8822,
    y1: 215.1651,
    x2: 167.8499,
    y2: 220.7175,
    gradientTransform: "matrix(1 0 0 -1 0 289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDEE07"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116216423344500224560000002210068444900369842_)"
    },
    d: "M175.26,77.39 c-7.44-5.38-16.3-8.85-26.33-10.73l0.34,0.84c9.84,2.21,18.49,6.02,25.66,11.84C175.03,78.66,175.13,78,175.26,77.39z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000007417782564062269750000003208484368514598274_",
    gradientUnits: "userSpaceOnUse",
    x1: 180.1941,
    y1: 185.4358,
    x2: 192.0438,
    y2: 194.8785,
    gradientTransform: "matrix(1 0 0 -1 0 289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDEE07"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000007417782564062269750000003208484368514598274_)"
    },
    d: "M169.53,97.84c0,0,1.25,9.64,15.16,14.46 c-2.53,0.69-5.06,1.15-7.57,1.42c3.37-0.16,6.78-0.69,10.21-1.62c-13.91-4.81-15.16-14.46-15.16-14.46 c5.75-2.82,12.12-4.75,18.59-5.45C183.4,92.6,176.07,94.63,169.53,97.84z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029755249574384287730000011606829893584681123_",
    gradientUnits: "userSpaceOnUse",
    x1: 168.2631,
    y1: 156.6293,
    x2: 179.5837,
    y2: 165.6503,
    gradientTransform: "matrix(1 0 0 -1 0 289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDEE07"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029755249574384287730000011606829893584681123_)"
    },
    d: "M156,126.49 c-2.05-0.86-3.94-1.91-5.54-3.14c8.02,11.29,26.57,15.53,40.59,14.07C178.97,138.05,164.39,134.66,156,126.49z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165214187663602543300000018292640279130690183_",
    gradientUnits: "userSpaceOnUse",
    x1: 217.6417,
    y1: 203.4198,
    x2: 220.8182,
    y2: 205.9512,
    gradientTransform: "matrix(1 0 0 -1 0 289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDEE07"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165214187663602543300000018292640279130690183_)"
    },
    d: "M213.2,83.32c0.03,0.2,0.09,0.4,0.13,0.6 c3.38,0.56,6.83,1.44,10.36,2.64c-0.45-0.48-0.9-0.95-1.35-1.42C219.23,84.28,216.19,83.65,213.2,83.32z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000050646115966877033720000014967147449551643824_",
    gradientUnits: "userSpaceOnUse",
    x1: 163.4331,
    y1: 172.6488,
    x2: 174.7592,
    y2: 181.6742,
    gradientTransform: "matrix(1 0 0 -1 0 289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDEE07"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000050646115966877033720000014967147449551643824_)"
    },
    d: "M173.97,129.05 c6.13-0.21,11.51-2.1,13.65-5.9c-28.12-0.52-36.52-11.04-38.97-16.27c-1.25-0.83-2.46-1.73-3.62-2.7c0,0,2.43,18.48,39.93,19.17 C183.15,126.6,178.96,128.44,173.97,129.05z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000149361165515750901990000010722912821117002649_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.594,
    y1: 216.6184,
    x2: 120.9695,
    y2: 220.1052,
    gradientTransform: "matrix(1 0 0 -1 0 289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDEE07"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000149361165515750901990000010722912821117002649_)"
    },
    d: "M119.87,67.39 c-0.97,0.47-1.94,0.91-2.91,1.37l-1.63,7.21c0.99-0.58,1.98-1.11,2.96-1.61L119.87,67.39z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129194971573157459520000005717062414964030891_",
    gradientUnits: "userSpaceOnUse",
    x1: 140.2647,
    y1: 216.0618,
    x2: 145.5301,
    y2: 220.2576,
    gradientTransform: "matrix(1 0 0 -1 0 289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDEE07"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129194971573157459520000005717062414964030891_)"
    },
    d: "M148.53,72.36 c-5.13-2.06-10.24-2.7-15.34-2.08c5.33-0.19,10.68,1.01,16.04,3.81L148.53,72.36z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142874588988254949340000003302955737382442935_",
    gradientUnits: "userSpaceOnUse",
    x1: 64.4986,
    y1: 201.2255,
    x2: 75.6719,
    y2: 210.1292,
    gradientTransform: "matrix(1 0 0 -1 0 289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDEE07"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142874588988254949340000003302955737382442935_)"
    },
    d: "M48.9,77.87 c-0.89,0.06-1.78,0.12-2.68,0.16c0,0,8.54,11.98,41.45,15.59c-0.66-0.26-1.31-0.52-1.95-0.79C57.62,88.81,49.43,78.57,48.9,77.87z "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M547.64,142.91V75.34h48.76c8.65,0,14.31,0.07,16.98,0.2s5.46,0.5,8.37,1.09 c6.76,1.39,11.17,5.21,13.22,11.48c0.76,2.38,1.27,4.93,1.53,7.65s0.4,6.84,0.4,12.35c0,6.04-0.16,10.61-0.47,13.71 s-0.9,5.92-1.76,8.46c-2.01,5.94-6.15,9.6-12.42,10.99c-2.94,0.66-6.07,1.1-9.41,1.31c-3.33,0.22-8.8,0.32-16.39,0.32h-48.81 V142.91z M567.93,125.69h28.66c5.28,0,9.17-0.17,11.66-0.52s4.25-0.95,5.27-1.81c1.12-0.96,1.91-2.47,2.38-4.55 c0.46-2.08,0.69-5.21,0.69-9.41c0-4.19-0.2-7.34-0.59-9.45c-0.4-2.11-1.09-3.73-2.08-4.85c-1.12-1.22-2.75-2-4.88-2.35 s-6.34-0.52-12.65-0.52h-28.46L567.93,125.69L567.93,125.69z M653.12,75.34h21.63v67.57h-21.63V75.34z M800.22,75.34h36.09 l35.39,50.39h2.13l-0.5-50.39h20.94v67.57h-35.79l-35.54-50.39h-2.23l0.45,50.39h-20.94L800.22,75.34L800.22,75.34z M907.09,75.34 h81.78v17.23h-30.05v50.34h-21.63V92.57h-30.1V75.34z M501.11,75.34h-31.98l-35.84,67.57h23.51l26.14-51.83h4.11l13.02,25.59h-22.7 l-7.43,14.8h37.36l5.79,11.44h23.36L501.11,75.34z M753.7,75.34h-31.98l-35.84,67.57h23.51l26.14-51.83h4.11l13.02,25.59h-22.7 l-7.43,14.8h37.36l5.79,11.44h23.36L753.7,75.34z M421.27,120.44c-1.88-2.14-4.98-3.38-9.31-3.71c3.66-0.56,6.4-1.58,8.22-3.07 c1.68-1.39,2.83-3.23,3.44-5.54c0.61-2.31,0.92-5.92,0.92-10.84c0-5.84-0.48-10.12-1.44-12.85c-0.96-2.72-2.72-4.86-5.3-6.41 c-2.15-1.32-4.37-2.09-6.68-2.3c-2.31-0.21-9.31-0.34-20.99-0.37h-49.75v67.57h20.59v-16.87v-0.31v-16.88v-1.73v-14.9h28.91 c4.75,0.03,7.63,0.08,8.64,0.15s1.87,0.26,2.6,0.59c1.02,0.49,1.74,1.29,2.15,2.38s0.62,2.74,0.62,4.95c0,2.24-0.18,3.92-0.54,5.02 c-0.36,1.11-0.99,1.94-1.88,2.5c-0.69,0.43-1.53,0.68-2.5,0.77c-0.97,0.08-3.99,0.17-9.03,0.27h-20.33l-8.48,16.88h28.85 c4.26,0,7.05,0.11,8.39,0.32c1.34,0.22,2.38,0.72,3.14,1.51c0.76,0.86,1.28,2.09,1.56,3.69s0.42,4.28,0.42,8.04v3.61h20.3v-6.29 c0-5.84-0.15-9.68-0.45-11.51S422.36,121.73,421.27,120.44z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M360.29,179.35l13.88,26.29h-4.42l-3.12-5.84h-18.76l-3.07,5.84h-4.42l13.83-26.29H360.29z M364.94,196.3 l-7.15-13.8h-0.99l-7.15,13.8H364.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M393.95,190.92c6.12,0,9.98,0.36,11.57,1.08c1.98,0.89,2.96,3.05,2.96,6.46c0,3.23-1.19,5.34-3.57,6.34 c-1.95,0.82-5.9,1.23-11.84,1.23c-6.43,0-10.57-0.7-12.41-2.11c-1.41-1.07-2.11-3.42-2.11-7.04h3.92c0,2.48,0.55,4.04,1.65,4.66 c1.1,0.64,4.1,0.96,8.99,0.96c4.79,0,7.91-0.23,9.34-0.69c1.41-0.46,2.11-1.57,2.11-3.34c0-1.8-0.53-2.91-1.58-3.34 c-1.08-0.44-4.09-0.66-9.04-0.66c-6.04,0-10.1-0.73-12.18-2.19c-1.59-1.1-2.38-3.09-2.38-5.96c0-3.1,0.96-5.11,2.88-6.03 c1.9-0.9,5.79-1.35,11.68-1.35c5.87,0,9.72,0.71,11.57,2.12c1.46,1.13,2.2,3.33,2.2,6.61h-3.85c0-2.25-0.58-3.67-1.73-4.26 c-1.15-0.59-3.88-0.89-8.19-0.89c-3.68,0-5.95,0.05-6.8,0.16c-2.56,0.31-3.84,1.52-3.84,3.65c0,1.79,0.69,3.01,2.07,3.65 C386.77,190.6,389.62,190.92,393.95,190.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M429.65,190.92c6.12,0,9.98,0.36,11.57,1.08c1.98,0.89,2.96,3.05,2.96,6.46c0,3.23-1.19,5.34-3.57,6.34 c-1.95,0.82-5.9,1.23-11.84,1.23c-6.43,0-10.57-0.7-12.41-2.11c-1.41-1.07-2.11-3.42-2.11-7.04h3.92c0,2.48,0.55,4.04,1.65,4.66 c1.1,0.64,4.1,0.96,8.99,0.96c4.79,0,7.91-0.23,9.34-0.69c1.41-0.46,2.11-1.57,2.11-3.34c0-1.8-0.53-2.91-1.58-3.34 c-1.08-0.44-4.09-0.66-9.04-0.66c-6.04,0-10.1-0.73-12.18-2.19c-1.59-1.1-2.38-3.09-2.38-5.96c0-3.1,0.96-5.11,2.88-6.03 c1.9-0.9,5.79-1.35,11.68-1.35c5.87,0,9.72,0.71,11.57,2.12c1.46,1.13,2.2,3.33,2.2,6.61h-3.85c0-2.25-0.58-3.67-1.73-4.26 c-1.15-0.59-3.88-0.89-8.19-0.89c-3.68,0-5.95,0.05-6.8,0.16c-2.56,0.31-3.84,1.52-3.84,3.65c0,1.79,0.69,3.01,2.07,3.65 C422.47,190.6,425.32,190.92,429.65,190.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M455.48,205.64h-3.92v-26.29h3.92V205.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M477.58,190.92c6.12,0,9.98,0.36,11.57,1.08c1.98,0.89,2.96,3.05,2.96,6.46c0,3.23-1.19,5.34-3.57,6.34 c-1.95,0.82-5.9,1.23-11.84,1.23c-6.43,0-10.57-0.7-12.41-2.11c-1.41-1.07-2.11-3.42-2.11-7.04h3.92c0,2.48,0.55,4.04,1.65,4.66 c1.1,0.64,4.1,0.96,8.99,0.96c4.79,0,7.91-0.23,9.34-0.69c1.41-0.46,2.11-1.57,2.11-3.34c0-1.8-0.53-2.91-1.58-3.34 c-1.08-0.44-4.09-0.66-9.04-0.66c-6.04,0-10.1-0.73-12.18-2.19c-1.59-1.1-2.38-3.09-2.38-5.96c0-3.1,0.96-5.11,2.88-6.03 c1.9-0.9,5.79-1.35,11.68-1.35c5.87,0,9.72,0.71,11.57,2.12c1.46,1.13,2.2,3.33,2.2,6.61h-3.85c0-2.25-0.58-3.67-1.73-4.26 c-1.15-0.59-3.88-0.89-8.19-0.89c-3.68,0-5.95,0.05-6.8,0.16c-2.56,0.31-3.84,1.52-3.84,3.65c0,1.79,0.69,3.01,2.07,3.65 C470.39,190.6,473.25,190.92,477.58,190.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M498.33,179.35h27.48v3.54h-11.77v22.75h-3.92v-22.75h-11.79L498.33,179.35L498.33,179.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M549.6,179.35l13.88,26.29h-4.42l-3.12-5.84h-18.76l-3.07,5.84h-4.42l13.83-26.29H549.6z M554.25,196.3 l-7.15-13.8h-0.99l-7.15,13.8H554.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M568.97,179.31h5.73l22.56,23.06v-23.06h3.92v26.33h-5.92l-22.37-22.87v22.87h-3.92V179.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M613.75,192.53c0,4.79,0.51,7.65,1.54,8.58c1.03,0.92,4.16,1.38,9.41,1.38c4.9,0,7.88-0.27,8.96-0.81 c1.25-0.64,1.88-2.37,1.88-5.19h3.92c0,4.18-0.86,6.81-2.57,7.88c-1.75,1.1-5.81,1.65-12.19,1.65c-6.48,0-10.58-0.77-12.3-2.31 c-1.71-1.54-2.57-5.27-2.57-11.18c0-5.94,0.86-9.7,2.57-11.26c1.7-1.54,5.8-2.31,12.3-2.31c6.41,0,10.47,0.54,12.18,1.61 c1.72,1.08,2.57,3.71,2.57,7.92h-3.92c0-2.82-0.58-4.52-1.73-5.11c-1.15-0.56-4.19-0.84-9.11-0.84c-5.28,0-8.42,0.45-9.41,1.35 C614.26,184.81,613.75,187.69,613.75,192.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M646.92,179.35h25.17v3.54h-21.25v7.65h20.52v3.54h-20.52v8.03h21.25v3.54h-25.17V179.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M714.59,190.92c6.12,0,9.98,0.36,11.57,1.08c1.98,0.89,2.96,3.05,2.96,6.46c0,3.23-1.19,5.34-3.57,6.34 c-1.95,0.82-5.9,1.23-11.84,1.23c-6.43,0-10.57-0.7-12.41-2.11c-1.41-1.07-2.11-3.42-2.11-7.04h3.92c0,2.48,0.55,4.04,1.65,4.66 c1.1,0.64,4.1,0.96,8.99,0.96c4.79,0,7.91-0.23,9.34-0.69c1.41-0.46,2.11-1.57,2.11-3.34c0-1.8-0.53-2.91-1.58-3.34 c-1.08-0.44-4.09-0.66-9.04-0.66c-6.04,0-10.1-0.73-12.18-2.19c-1.59-1.1-2.38-3.09-2.38-5.96c0-3.1,0.96-5.11,2.88-6.03 c1.9-0.9,5.79-1.35,11.68-1.35c5.87,0,9.72,0.71,11.57,2.12c1.46,1.13,2.2,3.33,2.2,6.61h-3.85c0-2.25-0.58-3.67-1.73-4.26 c-1.15-0.59-3.88-0.89-8.19-0.89c-3.68,0-5.95,0.05-6.8,0.16c-2.56,0.31-3.84,1.52-3.84,3.65c0,1.79,0.69,3.01,2.07,3.65 C707.41,190.6,710.26,190.92,714.59,190.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M735.42,179.35h25.17v3.54h-21.25v7.65h20.52v3.54h-20.52v8.03h21.25v3.54h-25.17V179.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M772.75,192.53c0,4.79,0.51,7.65,1.54,8.58c1.03,0.92,4.16,1.38,9.41,1.38c4.9,0,7.88-0.27,8.96-0.81 c1.25-0.64,1.88-2.37,1.88-5.19h3.92c0,4.18-0.86,6.81-2.57,7.88c-1.75,1.1-5.81,1.65-12.19,1.65c-6.48,0-10.58-0.77-12.3-2.31 c-1.71-1.54-2.57-5.27-2.57-11.18c0-5.94,0.86-9.7,2.57-11.26c1.7-1.54,5.8-2.31,12.3-2.31c6.41,0,10.47,0.54,12.18,1.61 c1.72,1.08,2.57,3.71,2.57,7.92h-3.92c0-2.82-0.58-4.52-1.73-5.11c-1.15-0.56-4.19-0.84-9.11-0.84c-5.28,0-8.42,0.45-9.41,1.35 C773.26,184.81,772.75,187.69,772.75,192.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M809.91,197.99c0,2.05,0.58,3.31,1.73,3.76c1.13,0.49,4.16,0.73,9.07,0.73c4.97,0,8.02-0.24,9.15-0.73 c1.13-0.46,1.69-1.71,1.69-3.76v-18.64h3.92v18.64c0,3.61-0.72,5.83-2.15,6.65c-1.59,0.92-5.79,1.38-12.61,1.38 c-6.79,0-10.94-0.44-12.45-1.3c-1.51-0.88-2.27-3.12-2.27-6.73v-18.64h3.92L809.91,197.99L809.91,197.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M865.87,179.35c2.23,0,3.94,0.76,5.15,2.27c1.2,1.54,1.8,3.58,1.8,6.11c0,2.18-0.35,3.8-1.04,4.88 c-0.49,0.77-1.27,1.39-2.35,1.85c0.95,0.39,1.7,0.89,2.24,1.5c0.77,0.87,1.15,1.94,1.15,3.23v6.46h-3.88v-6.46 c0-0.87-0.41-1.6-1.23-2.2c-0.84-0.56-1.86-0.85-3.04-0.85h-18.48v9.5h-3.92v-26.29H865.87z M846.19,192.57h18.09 c1.44,0,2.5-0.26,3.19-0.77c0.98-0.71,1.46-2.07,1.46-4.07s-0.5-3.36-1.5-4.11c-0.66-0.49-1.71-0.73-3.15-0.73h-18.09V192.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M885.67,205.64h-3.92v-26.29h3.92V205.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M892.82,179.35h27.48v3.54h-11.77v22.75h-3.92v-22.75h-11.79V179.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M953.65,179.35h5.26l-15.57,15.76v10.53h-3.96v-10.53l-15.52-15.76h5.26l12.26,12.5L953.65,179.35z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000151536016260237362410000015414507962633730984_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.0445,
    y1: 160.925,
    x2: 228.8345,
    y2: 160.925,
    gradientTransform: "matrix(1 0 0 -1 0 289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDEE07"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000151536016260237362410000015414507962633730984_)"
    },
    d: "M228.84,126.77 c-1.03,0.88-2.26,1.69-3.79,2.37c0,0,0.11,0.1,0.29,0.24C226.77,128.61,227.92,127.72,228.84,126.77z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131344056746334389380000004967010961559958428_",
    gradientUnits: "userSpaceOnUse",
    x1: 216.2154,
    y1: 167.0479,
    x2: 229.09,
    y2: 167.0479,
    gradientTransform: "matrix(1 0 0 -1 0 289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDEE07"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000131344056746334389380000004967010961559958428_)"
    },
    d: "M217.27,125.35 c0.61-8.65,6.12-9.88,9.75-15.3c-0.06-0.31-0.1-0.5-0.1-0.5c-3.55,6.66-9.92,7.34-10.58,16.67c-1.23,7.52,6.91,11.01,12.75,5.29 c-0.03,0-0.05,0-0.08,0C223.29,135.95,216.11,132.45,217.27,125.35z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000117647497081005993280000011996567463425689784_",
    gradientUnits: "userSpaceOnUse",
    x1: 231.0148,
    y1: 171.32,
    x2: 232.5448,
    y2: 171.32,
    gradientTransform: "matrix(1 0 0 -1 0 289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDEE07"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000117647497081005993280000011996567463425689784_)"
    },
    d: "M232.54,117.15 c-0.01-0.32-0.03-0.51-0.03-0.51c-0.43,0.81-0.95,1.5-1.5,2.08C231.55,118.28,232.07,117.76,232.54,117.15z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163071759741730611240000011971462270771986095_",
    gradientUnits: "userSpaceOnUse",
    x1: 192.4048,
    y1: 265.6484,
    x2: 46.2325,
    y2: 197.4764,
    gradientTransform: "matrix(1 0 0 -1 0 289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDEE07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9900"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163071759741730611240000011971462270771986095_)"
    },
    d: "M239.82,37.57 c-23.02-9.78-48.18-15.49-74.6-16.19c-1.85-0.03-3.69-0.08-5.54-0.08c-0.03,0-0.05,0-0.08,0c-1.88,0-3.76,0.04-5.64,0.08 c-46.46,1.27-89.05,18-122.84,45.22c0.36,10.47,1.35,20.81,2.9,30.98c0.76-0.33,1.49-0.65,2.2-0.95 c-1.38-9.52-2.28-19.17-2.62-28.95c33.79-27.22,76.38-43.94,122.84-45.22c1.88-0.04,3.76-0.08,5.64-0.08c0.03,0,0.05,0,0.08,0 c1.85,0,3.69,0.04,5.54,0.08c26.42,0.7,51.58,6.41,74.6,16.19c-7.35-4.26-15-8.06-22.89-11.4 C226.43,30.32,233.24,33.76,239.82,37.57z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoudpt);
export default __webpack_public_path__ + "static/media/Logoudpt.a687b7a8a1e96488e94dafd8e9b0a962.svg";
export { ForwardRef as ReactComponent };